export const handleChangeDataCategories = (name, value) => ({
    type: 'CHANGE_DATA_CATEGORIES', name, value
});